import { BackendModel, BackendService } from "../../core/backend.service";
import { AprobacionDocumento } from "./aprobacionDocumento.model";
import { OperationalParametric } from "../../cliente/operationalParametric.model";
import { MontoCompra } from "../../cliente/montoCompra.model";
import { User } from "../../security/user/user.model";

export class AprobacionCliente extends BackendModel {

  static path= 'estado_aprobacion_rechazo/';
  id: number;
  documentos: AprobacionDocumento[] = [];
  fechaCreacion: Date;
  nivelesAprobacion: OperationalParametric[] = [];
  motivoRechazo: string;
  enviarNotificacion: boolean;
  aprobado: boolean;
  estado: OperationalParametric;
  montoCompra: MontoCompra;
  usuarioCambioEstado: User;

  constructor(protected backendService: BackendService, model?: AprobacionCliente) {
    super(backendService, model);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared-components/validar-documentacion/aprobacionCliente.model.ts